<template>
  <div>
    <div class="text-right mb-1">
      <b-button
        variant="outline-primary"
        pill
        @click="createDevice"
        v-if="hasPermission('create_device')"
      >
        <feather-icon icon="PlusIcon" class="mr-50" />
        <span class="align-middle">Add New</span>
      </b-button>
    </div>

    <b-card class="mt-3">
      <b-row class="mb-1" align-v="center">
        <b-col md="7">
          <div v-if="searchType">
            <b-form-group
              label="site"
              label-for="name"
              class="w-50"
              v-if="searchType.value === 1"
            >
              <b-input-group>
                <template #prepend> </template>
              </b-input-group>
              <v-select
                label="name"
                v-model="site"
                placeholder="Select Site"
                :options="sites"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>

            <b-form-group
              label="Name"
              label-for="name"
              class="w-50"
              v-if="searchType.value === 2"
            >
              <b-form-input
                id="name"
                v-model="name"
                v-restrict="regex"
                placeholder="Device Name"
                required
              />
            </b-form-group>
          </div>
        </b-col>
        <b-col md="3">
          <b-form-group label="Search Type" label-for="searchType">
            <v-select
              id="searchType"
              v-model="searchType"
              :options="searchTypes"
              placeholder="Search Type"
              label="name"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-button variant="primary" pill @click="search">
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">Search</span>
          </b-button>
        </b-col>
      </b-row>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="devices"
        details-td-class="m-1 p-1"
        small
        v-if="hasPermission('read_device')"
        :per-page="0"
      >
        

        <template #cell(site_data)="row">
          {{
            row.item.site_data ? row.item.site_data.name : ""
          }}
        </template>

        <template #cell(building_data)="row">
          {{
            row.item.building_data ? row.item.building_data.name : ""
          }}
        </template>

        
        <template #cell(manage)="row">
          <b-button
            variant="success"
            pill
            size="sm"
            class="mr-50"
            @click="editDevice(row.item)"
            v-if="hasPermission('update_device')"
          >
            Edit
          </b-button>
        </template>
      </b-table>
      <b-pagination
        size="md"
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
      ></b-pagination>
    </b-card>
    <CreateDeviceModal
      @modalClosed="onModalClosed"
      :key="`create-${createDeviceModalCount}`"
    />
    <EditDeviceModal
      :device="device"
      @modalClosed="onModalClosed"
      :key="`edit-${editDeviceModalCount}`"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueSelectPaginated from "@/components/ui/VueSelectPaginated.vue";
import CreateDeviceModal from "@/components/device/CreateDeviceModal.vue";
import EditDeviceModal from "@/components/device/EditDeviceModal.vue";
import util from "@/util.js";
import VueGauge from 'vue-gauge';


export default {
  components: {
    CreateDeviceModal,
    EditDeviceModal,
    VueSelectPaginated,
    VueGauge,
  },
  data() {
    return {
      fields: [
        { key: "name", label: "Device Name" },
        { key: "site_data", label: "Site" },
        { key: "building_data", label: "Building" },
        { key: "manage", label: "Actions" },
      ],
      
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      devices: [],
      device: null,
      createDeviceModalCount: 0,
      editDeviceModalCount: 0,
      searchTypes: [
        { value: 1, name: "site" },
        { value: 2, name: "name" },
      ],
      searchType: null,
      name: "",
      site: "",
      sites: []
    };
  },
  mixins: [util],
  created() {
    this.searchType = this.searchTypes[0];
  },
  async mounted() {
    await this.fetchPaginatedData();

    const sites =  await this.getSitesDDL();
    this.sites = sites.data;
  },
  methods: {
    ...mapActions({
      getSitesDDL: "appData/getSitesDDL",
      getDevices: "appData/getDevices",
    }),
    async search() {
      if (this.searchType) {
        switch (this.searchType.value) {
          case 1:
            this.name = "";
            break;
          case 2:
            this.site = "";
            break;
        }
      } else {
        this.name = "";
        this.site = "";
      }
      this.currentPage = 1;
      await this.fetchPaginatedData();
    },
    async fetchPaginatedData() {
      try {
        const res = await this.getDevices({
          pageNumber: this.currentPage,      
          name: this.name,      
          site: this.site,      
        });
        this.devices = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
      } catch (error) {
        this.displayError(error);
      }
    },
    createDevice() {
      this.createDeviceModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("create-device-modal");
      });
    },
    editDevice(device) {
      this.device = device;
      this.editDeviceModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("edit-device-modal");
      });
    },
    async removeDevice(device) {
      this.device = device;
      try {
        const res = await this.deleteDevice({
          pk: this.device.id,
        });
        if (res.status === 204) {
          this.$swal({
            title: "Device deleted successfully",
            icon: "success",
          });
          if (
            (this.totalItems - 1) % this.perPage === 0 &&
            this.currentPage !== 1
          ) {
            this.currentPage -= 1;
          } else {
            await this.fetchPaginatedData();
          }
        }
      } catch (error) {
        this.displayError(error);
      }
    },
    async onModalClosed() {
      await this.fetchPaginatedData();
    },
  },
  computed: {
    ...mapGetters({
      hasPermission: "appData/hasPermission",
    }),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
};
</script>

<style></style>
